module.exports = __webpack_public_path__ + "img/Asset 2.56dab760.png";